<template>
  <div>
    <div class="columns is-multiline">
      <div class="column is-half">
        <!-- 저장 -->
        <div class="btn-group-justify-end">
          <button class="button is-primary" @click="saveData">저장하기</button>
        </div>

        <div class="box">
          <admin-box-item title="공통 팀노트 정보">
            <div class="columns is-multiline">
              <div class="column is-full">
                <admin-form-item label="*팀노트 이름">
                  <input class="input"
                         :value="name"
                         @input="e => name = e.target.value"
                         placeholder="팀노트명을 입력해주세요."
                         type="text">
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
  import LpAdmDropInput from "../../../module/common/LpAdmDropInput";
  import GroupMixin from "@/mixins/GroupMixin"
  import CreateMixin from "@/mixins/CreateMixin"

  export default {
    name: 'GroupBoardBaseCreate',
    mixins: [
      GroupMixin,
      CreateMixin
    ],
    components: {
      LpAdmDropInput
    },
    data() {
      return {
        name: ''
      }
    },
    created() {
      this.getData();
    },
    computed: {
      selectedGroup() {
        let label = '';
        this.groupList.forEach(item=>{
          if(item.value===this.group_id) {
            label = item.label;
          }
        })
        return label;
      },
    },
    watch: {
      $route() {
        this.getData();
      }
    },
    methods: {
      getData() {
        this.name = '';
        let board_id = this.$route.query.board_id;
        if(board_id) {
          this.$axios.get(this.getUrl(`group/board/base/${board_id}`)).then(res=>{
            this.name = res.data.name;
          })
        }
      },
      saveData() {
        let board_id = this.$route.query.board_id;
        if(this.name==='') {
          this.toast('팀노트명을 입력하세요.');
          return;
        }
        if(board_id) {
         this.$axios.patch(this.getUrl(`group/board/base/${board_id}`), {
           name: this.name
         }).then(res=>{
           if(res.status===200) {
             this.toast('저장되었습니다.');
             this.$router.replace(this.getPath('group/board/base'));
           }
         })
        }
        else {
          this.$axios.post(this.getUrl(`group/board/base`), {
            name: this.name
          }).then(res=>{
            if(res.status===200) {
              this.toast('저장되었습니다.');
              this.$router.replace(this.getPath('group/board/base'));
            }
          })
        }
      }
    }
  }
</script>
<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'
</style>
